import { Button, Modal } from "react-bootstrap";

export function ConfirmDeletionModal ({
  show,
  handleClose,
  title,
  triggerDelete,
  body
}) {

  return <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {body || <>
        <p>Esta acción no podrá ser revertida.</p>
        <p>¿Aún deseas continuar?</p>
      </>}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Cancelar
      </Button>
      {triggerDelete && <Button variant="danger" onClick={triggerDelete}>
        Borrar
      </Button>}
    </Modal.Footer>
  </Modal>
}